class ProductTabs extends HTMLElement {
  connectedCallback() {
    this._handleClick = (e) => {
      const tab = e.target.closest('.product-tabs-tab');
      if (tab) this.activateTab(tab.dataset.tabId);
    };
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
  }

  activateTab(tabId) {
    this.querySelectorAll('.product-tabs-tab').forEach(tab =>
      tab.classList.toggle('is-active', tab.dataset.tabId === tabId)
    );
    this.querySelectorAll('.product-tabs-panel').forEach(panel =>
      panel.classList.toggle('is-active', panel.id === tabId)
    );
  }
}

customElements.define('product-tabs', ProductTabs);
